import * as svg from "./svg";

export const ToastMessage = ({
    message,
    variant = "success"
}: {
    message: string;
    variant?: "success" | "error";
}) => {
    const isError = variant === "error";

    return (
        <div
            className={`flex animate-bottom-slide items-center gap-2 rounded-full px-3 py-1 text-sm font-semibold text-white shadow-sm ${
                isError ? "bg-red-600" : "bg-primary-500"
            }`}
        >
            <div className={isError ? "text-white" : "text-primary-500"}>
                {isError ? svg.warning : svg.solidCheckmark}
            </div>
            <div>{message}</div>
        </div>
    );
};
